import React, { forwardRef } from "react";
import styles from "./QuizContainer.module.scss";

const QuizContainer = forwardRef(({ children, title, currentStep, totalSteps, onBack, stepId }, ref) => {
  return (
    <div className={styles.QuizContainer} ref={ref}>
      <div className={styles.content}>{children}</div>
    </div>
  );
});

export default QuizContainer;